function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Modifier from 'ember-modifier';
import { registerDestructor } from '@ember/destroyable';
export default class DidResizeModifier extends Modifier {
  constructor() {
    super(...arguments);
    // Public API
    _defineProperty(this, "element", void 0);
    _defineProperty(this, "handler", void 0);
    _defineProperty(this, "options", {});
    if (!('ResizeObserver' in window)) {
      return;
    }
    if (!DidResizeModifier.observer) {
      DidResizeModifier.handlers = new WeakMap();
      DidResizeModifier.observer = new ResizeObserver((entries, observer) => {
        window.requestAnimationFrame(() => {
          for (let entry of entries) {
            const handler = DidResizeModifier.handlers.get(entry.target);
            if (handler) handler(entry, observer);
          }
        });
      });
    }
    registerDestructor(this, unobserve);
  }
  modify(element, positional /*, named*/) {
    unobserve(this);
    this.element = element;
    const [handler, options] = positional;

    // Save arguments for when we need them
    this.handler = handler;
    this.options = options || this.options;
    this.observe();
  }
  observe() {
    if (DidResizeModifier.observer) {
      this.addHandler();
      DidResizeModifier.observer.observe(this.element, this.options);
    }
  }
  addHandler() {
    DidResizeModifier.handlers.set(this.element, this.handler);
  }
  removeHandler() {
    DidResizeModifier.handlers.delete(this.element);
  }
}

/**
 *
 * @param {DidResizeModifier} instance
 */
// Private API
_defineProperty(DidResizeModifier, "observer", null);
_defineProperty(DidResizeModifier, "handlers", null);
function unobserve(instance) {
  if (instance.element && DidResizeModifier.observer) {
    DidResizeModifier.observer.unobserve(instance.element);
    instance.removeHandler();
  }
}